<script setup>
</script>

<template>
  <h2 class="title_sub1">パスワード設定完了</h2>
  <div class="com_checked_cnt1">
    <img src="/front/assets/common/img/check_fig1.png"
      alt="" class="check_fig1">
    <p>パスワードの設定が完了しました</p>
      <a href="/front/login" class="btn com_btn4 cl1 com_strong1 com_mgt10s">ログイン</a>
  </div>
</template>

<style scoped>
</style>
